<template><div><h1>VUX V2.1.0Rc.46 发布日志</h1>
<h2><a href="/zh-CN/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[feature] 添加更多`less`变量 #896 @erguotou520</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持配置`取消`和`确定`的文字颜色 #715 @greedying</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持设置 `bar-active-color` #715 @greedying</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] 添加`less`变量 #896 @erguotou520</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 添加`slot=label`自定义label部分内容 #895 @erguotou520</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[enhance] 使用`svg`代替 `+` `-` 字符</li>
<li>[feature] 支持圆形按钮样式</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.46 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.46-204.vue?6b0fec01